// eslint-disable-next-line import/prefer-default-export
export enum DialogType {
  "Confirm",
  "CheckMapping",
}
